import { ApplyingBonusEffects } from './applying-bonus.effect';
import { CheckoutAnalyticsEffects } from './checkout-analytics.effects';
import { CheckoutInitEffects } from './checkout-init.effect';
import { CheckoutEffects } from './checkout.effect';
import { CustomerConsignmentEffects } from './customer-consignment.effect';
import { PaymentModesEffects } from './payment-modes.effect';
import { PickupShopsEffects } from './pickup-shops.effect';
import { ReceiptTypesEffects } from './receipt-types.effect';
import { SavedDeliveryAddressEffects } from './saved-delivery-address.effect';
import { ServicesEffects } from './services.effect';
import { TimeSlotsEffects } from './time-slots.effect';

export const effects: any[] = [
  CheckoutInitEffects,
  ReceiptTypesEffects,
  CheckoutEffects,
  SavedDeliveryAddressEffects,
  PaymentModesEffects,
  TimeSlotsEffects,
  ServicesEffects,
  PickupShopsEffects,
  CheckoutAnalyticsEffects,
  ApplyingBonusEffects,
  CustomerConsignmentEffects,
];
